import Masonry from 'masonry-layout'
import axios from 'axios'

class BlogLanding {
    constructor (theme, elem) {
        this.name = this.constructor.name
        this._theme = theme
        this._elem = elem
        this._currentPage = 1
        this._loading = false
        this._masonryLayout = null
        this._masonryContainer = null
        this._data = JSON.parse(elem.dataset.blogLanding)
        this._url = this._data.url
    }
    onInit () {
        this._masonryContainer = this._elem.querySelector('[data-blog-masonry]')
        if (this._masonryContainer) {
            this._masonryLayout = new Masonry(this._masonryContainer, {
                itemSelector: '.blog__grid__item',
                columnWidth: '.blog__grid__item',
                gutter: 20,
                fitWidth: true
            })
        }
        const button = this._elem.querySelector('[data-blog-load-more]')
        if (button) {
            button.addEventListener('click', (e) => { this.loadMore(e) })
        }
        this.buildPage()
        // window.masonry = this._masonryLayout
    }
    async loadMore (e) {
        let button = null
        if (e) {
            button = e.currentTarget
        }
        if (!this._loading) {
            this._currentPage++
            this._loading = true
            if (button) {
                button.classList.add('loading')
            }
            if (await this.buildPage()) {
                this._loading = false
                if (button) {
                    button.classList.remove('loading')
                }
            }
        }
    }
    async buildPage () {
        // https://masonry.desandro.com/methods.html
        // Ajax call the blog.json template
        // Run each article through buildItem
        // Create an array of elements based on the HTML returned from buildItem
        // Append onto masonry element
        // Check if last page - remove load button if so
        let toAppend = []
        let result = await this.getArticles()
        if (result) {
            for (let article of result.data.articles) {
                let newElem = document.createElement('div')
                newElem.classList.add('blog__grid__item')
                newElem.innerHTML = this.buildItem(article)
                toAppend.push(newElem)
                this._masonryContainer.appendChild(newElem)
                this._masonryLayout.appended(newElem)
            }
            const button = this._elem.querySelector('[data-blog-load-more]')
            if (button) {
                if (!result.data.next) {
                    button.classList.add('hidden')
                } else {
                    button.classList.remove('hidden')
                }
            }
        }
        if (toAppend.length > 0) {
            this._masonryLayout.layout()
        }
        return true
    }
    async getArticles () {
        let result = await axios.get(`${this._url}?view=json&page=${this._currentPage}`)
        return result
    }
    buildItem (article) {
        let image = ``
        let tags = ``
        let excerpt = ``
        let author = ``
        // let iconAuthor = `<svg xmlns="http://www.w3.org/2000/svg" width="17" height="19" viewBox="0 0 17 19"><g><g><g><path fill="#7b7b7b" d="M4.382 11.306a4.469 4.469 0 0 1 1.8-2.079l.485-.296-.355-.444a2.74 2.74 0 0 1-.6-1.687 2.792 2.792 0 0 1 2.79-2.79 2.792 2.792 0 0 1 2.79 2.786 2.75 2.75 0 0 1-.6 1.691l-.356.445.487.295a4.49 4.49 0 0 1 1.808 2.078.5.5 0 1 1-.919.388A3.5 3.5 0 0 0 8.5 9.57c-1.394.008-2.649.841-3.22 2.178a.495.495 0 0 1-.665.24.505.505 0 0 1-.232-.682m2.854-5.792A1.793 1.793 0 0 0 8.502 8.57c.98 0 1.782-.797 1.79-1.79 0-.987-.804-1.79-1.79-1.79-.479 0-.928.186-1.266.524"/></g><g><path fill="#7b7b7b" d="M17 13.5c0 1.379-1.121 2.5-2.5 2.5h-2.314l-3.361 2.88a.506.506 0 0 1-.329.12c-.105-.021-.26-.052-.352-.143L5.297 16H2.5A2.503 2.503 0 0 1 0 13.5v-11C0 1.122 1.122 0 2.5 0h12C15.879 0 17 1.122 17 2.5zm-1-11c0-.827-.673-1.5-1.5-1.5h-12C1.673 1 1 1.673 1 2.5v11c0 .827.673 1.5 1.5 1.5h3.004a.554.554 0 0 1 .351.143l2.668 2.678 3.152-2.701A.504.504 0 0 1 12 15h2.5c.827 0 1.5-.673 1.5-1.5z"/></g></g></g></svg>`
        let iconCalendar = `<svg xmlns="http://www.w3.org/2000/svg" width="19" height="21" viewBox="0 0 19 21"><g><g><g><path fill="#7b7b7b" d="M10 12.5a.5.5 0 1 0-1.002.002A.5.5 0 0 0 10 12.5"/></g><g><path fill="#7b7b7b" d="M9.5 17a.5.5 0 1 0-.002-1.002A.5.5 0 0 0 9.5 17"/></g><g><path fill="#7b7b7b" d="M5 12.5a.5.5 0 1 0-1.002.002A.5.5 0 0 0 5 12.5"/></g><g><path fill="#7b7b7b" d="M14.5 17c.275 0 .5-.225.5-.5s-.225-.5-.5-.5-.5.225-.5.5.225.5.5.5"/></g><g><path fill="#7b7b7b" d="M15 12.5c0-.275-.225-.5-.5-.5s-.5.225-.5.5.225.5.5.5.5-.225.5-.5"/></g><g><path fill="#7b7b7b" d="M19 18.5c0 1.379-1.121 2.5-2.5 2.5h-14A2.503 2.503 0 0 1 0 18.5v-14C0 3.122 1.122 2 2.5 2H4V.5a.5.5 0 0 1 1 0V2h9V.5a.5.5 0 0 1 1 0V2h1.5C17.879 2 19 3.122 19 4.5zM18 9H1v9.5c0 .827.673 1.5 1.5 1.5h14c.827 0 1.5-.673 1.5-1.5zm0-4.5c0-.827-.673-1.5-1.5-1.5H15v1.5a.5.5 0 0 1-1 0V3H5v1.5a.5.5 0 0 1-1 0V3H2.5C1.673 3 1 3.673 1 4.5V8h17z"/></g><g><path fill="#7b7b7b" d="M4.5 17a.5.5 0 1 0-.002-1.002A.5.5 0 0 0 4.5 17"/></g></g></g></svg>`
        if (article.has_image) {
            image = `
            <a href="${article.url}" title="${article.title}" >
                <div class="blog__grid__item__img" style="padding-top:${article.aspect_ratio}%">
                    <img src="${article.image}" alt="${article.title}">
                </div>
            </a>`
        }
        if (article.tags.length > 0) {
            let tagList = ``
            for (let tag of article.tags) {
                tagList += `<li>${tag}</li>`
            }
            tags = `
            <div class="blog__grid__item__tags">
                <ul>
                ${tagList}
                </ul>
            </div>`
        }
        if (article.excerpt) {
            excerpt = `
            <p>${article.excerpt}</p>
            `
        }
        // if (article.author) {
        //     author = `
        //     <div class="blog__grid__item__meta__author">${iconAuthor} ${article.author}</div>`
        // }
        let template = `

        <div class="blog__grid__item__inner">
            ${image}
            ${tags}
            <h5><a href="${article.url}" title="${article.title}">${article.title}</a></h5>
            ${excerpt}
            <div class="blog__grid__item__meta flex f-space-between">
                ${author}
                <div class="blog__grid__item__meta__date"><a href="${article.url}" title="${article.title}">${iconCalendar} ${article.date}</a></div>
            </div>
    
        </div>`

        return template
    }
}

export default BlogLanding



// WEBPACK FOOTER //
// ./src/resources/scripts/components/BlogLanding.js